/** Reading the strategy registry: one current version per strategy, older ones counted. */
import type { RegistryStrategyResponse } from "@/shared/api";

/** The latest published version of each strategy, in first-seen order. */
export function latestByStrategy(
  versions: readonly RegistryStrategyResponse[],
): readonly RegistryStrategyResponse[] {
  // The server names the version in force — the one the accounts follow — and
  // that answer is taken as given. Picking by date here put a second rule
  // beside the server's, and on a tie of time they disagreed: Обзор showed
  // every pool «приостановлена» while all three traded (2026-10-16).
  const named = versions.filter((item) => item.current === true);
  if (named.length > 0) return named;
  const latest = new Map<string, RegistryStrategyResponse>();
  for (const item of versions) {
    if (item.publication_state !== "PUBLISHED") continue;
    const seen = latest.get(item.strategy_id);
    // Ties (or no dates) break on the version, so the pick never depends on API order.
    const newer = (item.published_at ?? "") > (seen?.published_at ?? "")
      || ((item.published_at ?? "") === (seen?.published_at ?? "") && item.strategy_version.localeCompare(seen?.strategy_version ?? "", undefined, { numeric: true }) > 0);
    if (seen === undefined || newer) {
      latest.set(item.strategy_id, item);
    }
  }
  return [...latest.values()];
}

/** How many earlier published versions a strategy has behind its latest. */
export function earlierCount(versions: readonly RegistryStrategyResponse[], strategyId: string): number {
  return Math.max(0, versions.filter((item) => item.strategy_id === strategyId && item.publication_state === "PUBLISHED").length - 1);
}
